import React from 'react';
import { StackScreen } from '@banhala/ui-kit';
import { WebView } from 'shared/src/component/WebWebView';
import { useWebBaseURL } from 'shared/src/hooks';
import { isNotNil } from 'shared/src/utils';

export const ContentsScreen: React.FC = () => {
  const webBaseUrl = useWebBaseURL();

  return (
    <StackScreen title={'콘텐츠'} hideBackButton={true}>
      {isNotNil(webBaseUrl) && (
        <WebView source={{ uri: `${webBaseUrl}/contents/home` }} />
      )}
    </StackScreen>
  );
};
